module.exports = __webpack_public_path__ + "img/65736.15a56a57.png";